<template>
  <div class="card card-height">
    <div class="table-container">
      <table class="table create-billing table-width table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Reference No.</th>
            <th>Client Details</th>
            <th class="text-right">SubTotal Amount</th>
            <th class="text-right">VAT Amount</th>
            <th class="text-right">Discount</th>
            <th class="text-right">Redeem Point</th>
            <th class="text-right">Bill Amount</th>
            <th class="text-right">Paid Amount</th>
            <th class="text-right" v-for="mop in mopHeads" :key="mop.key">{{ mop.label }}</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(item, index) in tableItems"
            :key="index"
            :class="{
              'sale-has-return': item.has_return,
              'is-return': item.is_return
            }"
          >
            <td>{{ formatToDdMmmYy(item.date) }}</td>
            <td>{{ item.type }}</td>
            <td>
              {{ item.bill_number }}
              <span v-if="item.return_ref" class="small">
                [Ref # {{ item.return_ref }}]
              </span>
            </td>
            <td>{{ item.client_details }}</td>
            <td class="text-right">{{ commaFormat(item.subtotal_amount) }}</td>
            <td class="text-right">{{ commaFormat(item.vat_amount) }}</td>
            <td class="text-right">{{ commaFormat(item.discount_amount) }}</td>
            <td class="text-right">{{ commaFormat(item.redeem_point) }}</td>
            <td class="text-right">{{ commaFormat(item.bill_amount) }}</td>
            <td class="text-right">{{ commaFormat(item.paid_amount) }}</td>
            <td class="text-right" v-for="mop in mopHeads" :key="mop.key">
              {{ commaFormat((item.mop_heads && item.mop_heads[mop.key]) || 0) }}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="4"><strong>Total</strong></td>
            <td class="text-right"><strong>{{ commaFormat(totals.subtotal_amount) }}</strong></td>
            <td class="text-right"><strong>{{ commaFormat(totals.vat_amount) }}</strong></td>
            <td class="text-right"><strong>{{ commaFormat(totals.discount_amount) }}</strong></td>
            <td class="text-right"><strong>{{ commaFormat(totals.redeem_point) }}</strong></td>
            <td class="text-right"><strong>{{ commaFormat(totals.bill_amount) }}</strong></td>
            <td class="text-right"><strong>{{ commaFormat(totals.paid_amount) }}</strong></td>
            <td class="text-right" v-for="mop in mopHeads" :key="mop.key">
              <strong>{{ commaFormat((totals.mop_heads && totals.mop_heads[mop.key]) || 0) }}</strong>
            </td>
          </tr>
        </tfoot>
      </table>
      <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import useDate from '@/services/utils/day';
import figureFormatter from '@/services/utils/figureFormatter';

defineProps({
  tableItems: {
    type: Array,
    default: () => []
  },
  totals: {
    type: Object,
    default: () => ({})
  },
  mopHeads: {
    type: Array,
    default: () => []
  },
});

const { formatToDdMmmYy } = useDate();
const { commaFormat }     = figureFormatter();
</script>

<style scoped>
.card-height {
  min-height: 200px;
}
.sale-has-return {
  background-color: #fff8e1;
}
.is-return td{
  color: red;
}
</style>
